import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { Box, Button, FormControl, FormLabel, InputAdornment, TextField } from "@mui/material";
import companyCreditConfigService from "../../services/companyCreditConfig.service";
import { showErrorToaster, showSuccessToaster } from "../../helpers/utils/toaster";
import CircleLoader from "../../global/Loader/CircleLoader";

function formatServiceName(service) {
  const serviceNameMap = {
    AI_RANKING: "AI Ranking with Selection Report",
    AI_INTERVIEW: "AI Interview Question Generation",
    AI_INTERVIEW_REPORT: "AI Interview Per Candidate",
    ASSESSMENT: "Assessment Test Create",
    ASSESSMENT_REPORT: "Assessment Test Per Candidate",
    PSYCHOLOGY_TEST: "Psychology Test Create",
    PSYCHOLOGY_TEST_REPORT: "Psychology Test Per Candidate",
  };

  if (serviceNameMap[service]) {
    return serviceNameMap[service];
  }

  return service
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

const CreditConfigModal = ({ onClose, companyInfo }) => {
  const [creditConfigs, setCreditConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      configs: creditConfigs || [],
    },
  });

  useEffect(() => {
    if (success && creditConfigs) {
      reset({ configs: creditConfigs });
    }
  }, [success, reset]);

  useEffect(() => {
    setLoading(true);
    companyCreditConfigService
      .getCompanyCreditConfigs({ companyId: companyInfo.id })
      .then((res) => {
        console.log(res);
        if (res.status) {
          const initialData = res.data;
          setCreditConfigs(initialData);
          setSuccess(true);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onSubmit = (data) => {
    console.log("Form data:", data);

    companyCreditConfigService.saveCompanyCreditConfigs({ creditConfigs: data.configs, companyId: companyInfo.id }).then((res) => {
      if (res.status) {
        showSuccessToaster(res.message);
        onClose();
      } else {
        showErrorToaster(res.message);
      }
    });
  };

  if (loading) {
    return <CircleLoader />;
  }
  return (
    <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {creditConfigs?.map((item, index) => {
        if (!item?.service) return null;

        return (
          <FormControl key={item.service}>
            <FormLabel>{formatServiceName(item.service)}</FormLabel>
            <TextField
              size="small"
              type="number"
              step="0.1"
              {...register(`configs.${index}.amount`, {
                valueAsNumber: true,
                required: "Amount is required",
                min: { value: 0, message: "Must be >= 0" },
              })}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
              error={!!errors?.configs?.[index]?.amount}
              helperText={errors?.configs?.[index]?.amount?.message}
            />
            {/* hidden field for service */}
            <input type="hidden" {...register(`configs.${index}.service`)} defaultValue={item.service} />
          </FormControl>
        );
      })}

      <Button type="submit" variant="contained">
        Save
      </Button>
    </Box>
  );
};

export default CreditConfigModal;
